/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_UnauthorizedInputs */

const cs_api_error_unauthorized = /** @type {(inputs: Api_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relace vypršela. Přihlaste se znovu.`)
};

const en_api_error_unauthorized = /** @type {(inputs: Api_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session expired. Sign in again.`)
};

/**
* | output |
* | --- |
* | "Your session expired. Sign in again." |
*
* @param {Api_Error_UnauthorizedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_unauthorized = /** @type {((inputs?: Api_Error_UnauthorizedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_UnauthorizedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_unauthorized(inputs)
	return cs_api_error_unauthorized(inputs)
});